<template>
    <div class="pagination">
        <div class="summary">
            <p v-html="resultCount"></p>
        </div>

        <div class="buttons" v-if="last > 1">
            <a @click="goTo(1)" :class="1 == current ? 'disabled': ''">
                <i class="fal fa-angle-double-left"></i>
            </a>
            <a @click="goTo(Math.max(current - 1, 1))" :class="1 == current ? 'disabled': ''">
                <i class="fal fa-angle-left"></i>
            </a>
            <a v-for="n in range" @click="goTo(n)"><div class="circular" v-text="n" :class="{'active': n == current}"></div></a>
            <a @click="goTo(Math.min(current + 1, last))" :class="last == current ? 'disabled': ''">
                <i class="fal fa-angle-right"></i>
            </a>
            <a @click="goTo(last)" :class="last == current ? 'disabled': ''">
                <i class="fal fa-angle-double-right"></i>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                //
            }
        },

        computed: {
            range() {
                return Array.from({length: Math.min(3, this.last)}, (v, i) => {
                    if (this.current == 1) {
                        i++;
                    }
                    else if (this.current == this.last) {
                        i += this.current - 2;

                        //Special case if there are only two pages and you are on the last
                        if (this.current == 2) {
                            i++;
                        }
                    }
                    else {
                        i += this.current - 1;
                    }

                    return i;
                });
            },

            resultCount() {
                return `${this.current * 12 - 11} - ${(this.current - 1) * 12 + this.count} ${this.labels.of} ${this.total} ${this.labels.results}`;
            }
        },

        props: {
            current: {
                type: Number,
                required: true
            },

            last: {
                type: Number,
                required: true
            },

            total: {
                type: Number,
                required: true
            },

            count: {
                type: Number,
                required: true
            }
        },

        created() {

        },

        methods: {
            goTo(n) {
                this.$emit('loadPage', n);
            }
        }
    }
</script>
